import Button from "./Button";

export default function Heading({ params }) {
  const {
    button,
    headingType,
    align,
    verticalCentered,
    title,
    subtitle,
    description,
    note,
  } = params;
  const Tag = headingType;

  return (
    <>
      <div
        className={`ob-text-block ${align} ${
          verticalCentered === true ? "ob-centered" : ""
        }`}
      >
        <div className="ob-headline">
          <Tag
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          ></Tag>
        </div>
        {subtitle && (
          <p
            dangerouslySetInnerHTML={{
              __html: subtitle,
            }}
          ></p>
        )}

        {description && (
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
            className="ob-short-desc"
          ></div>
        )}

        <div>{button && <Button params={button} />}</div>
      </div>
      {note && <p className="note">{note}</p>}
    </>
  );
}
